// ProductApi.js

import apiServices from "../common/apiServices";

// Define the tag types related to products
export const addTagTypes = ['Product'];

// Enhance the base API service by adding product-related tag types
const ProductApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      // Fetch Product query (GET request to /products)
      getProduct: builder.query({
        query: () => ({
          url: `/products`,
        }),
        providesTags: ['Product'],
      }),
      // Fetch paginated products query (GET request to /products/paginated)
      getPaginatedProductsOld: builder.query({
        query: ({ page, size, sort, name, categoryId, subCategoryId }) => ({
          url: '/products/paginated',
          params: {
            page,
            size,
            sort,
            name,
            categoryId,
            subCategoryId,
          },
        }),
        providesTags: ['Product'],
      }),
       // ✅ New endpoint: Get product by ID
      getProductById: builder.query({
        query: (id) => ({
          url: `/products/${id}`,
        }),
        providesTags: ['Product'],
      }),

      getPaginatedProducts: builder.query({
        query: ({ page, size, sort, name, categoryId, subCategoryId }) => {
          const params = new URLSearchParams();
          params.append('page', page);
          params.append('size', size);
          if (sort) {
            if (Array.isArray(sort) && sort.length === 2) {
              // Join the sort field and order as "id,desc"
              params.append('sort', `${sort[0]},${sort[1]}`);
            } else if (Array.isArray(sort)) {
              // Fallback for more than 2 values
              params.append('sort', sort.join(','));
            } else {
              params.append('sort', sort);
            }
          }
          if (name) params.append('name', name);
          if (categoryId) params.append('categoryId', categoryId);
          if (subCategoryId) params.append('subCategoryId', subCategoryId);
          return { url: '/products/paginated', params };
        },
        providesTags: ['Products']
      }),
    }),
    overrideExisting: false,
  });

export default ProductApi;

// Exporting hooks for each endpoint to be used in components
export const {
  useGetProductQuery,
  useGetProductByIdQuery,
  useGetPaginatedProductsQuery,
} = ProductApi;
 
 